import {Module} from "vuex-smart-module";

import WarehouseAdminState from "@/store/modules/warehouse-admin/warehouse-admin-state";
import WarehouseAdminGetters from "@/store/modules/warehouse-admin/warehouse-admin-getters";
import WarehouseAdminMutations from "@/store/modules/warehouse-admin/warehouse-admin-mutations";
import WarehouseAdminActions from "@/store/modules/warehouse-admin/warehouse-admin-actions";

export default new Module({
    state: WarehouseAdminState,
    getters: WarehouseAdminGetters,
    mutations: WarehouseAdminMutations,
    actions: WarehouseAdminActions
});